import { GET_EB_BASVURU_OZELLIK_KURAL } from "../constants/requestUrls";
import { postRequest } from "../request";

const getEbBasvuruOzellikKural = (props) => {
    let data = {};
    if (props !== undefined)
        data = JSON.stringify(props);
  return postRequest({ url: GET_EB_BASVURU_OZELLIK_KURAL, data });
}

export default getEbBasvuruOzellikKural;